import React from 'react';
import useStyles from './styles';
import logo from '../../assets/menu-new.svg';
import Grid from '@material-ui/core/Grid';


type Props = {
  message: string,
};

const LoginHeader: React.FC<Props> = (props) => {
  const { message } = props;
  const classes = useStyles();

  return (
    <Grid container>
      <img className={classes.logo} src={logo} alt="logo" />
      <p className={classes.blurb}>{message}</p>
    </Grid>
  );
};

export default LoginHeader;
